import type { AuthenticationQueryParams } from '@dtos/query-params';
import { toPairs } from 'lodash';
import {
    action,
    computed,
    observable
} from 'mobx';

export interface IAuthenticationParamsStore extends Required<AuthenticationQueryParams> {
    readonly serialisedParams: string;
    readonly fullName: string;
    readonly params: AuthenticationQueryParams;

    setParams(params: AuthenticationQueryParams): void;
}

export class AuthenticationParamsStore implements IAuthenticationParamsStore {
    @observable
    authorizedRepresentativeId: string = '';

    @observable
    candidateFirstName: string = '';

    @observable
    candidateLastName: string = '';

    @action
    setParams(params: AuthenticationQueryParams) {
        this.authorizedRepresentativeId = params.authorizedRepresentativeId!;
        this.candidateFirstName = params.candidateFirstName!;
        this.candidateLastName = params.candidateLastName!;
    }

    @computed
    get fullName(): string {
        return `${this.candidateFirstName} ${this.candidateLastName}`;
    }

    @computed
    get params(): AuthenticationQueryParams {
        return {
            authorizedRepresentativeId: this.authorizedRepresentativeId,
            candidateFirstName: this.candidateFirstName,
            candidateLastName: this.candidateLastName
        };
    }

    @computed
    get serialisedParams(): string {
        const queryPairs = toPairs(this.params);

        return `?${queryPairs.map(pair => pair.join('=')).join('&')}`;
    }
}

export default AuthenticationParamsStore;



// WEBPACK FOOTER //
// ./src/stores/authentication/authentication-params-store.ts